import React from 'react';
import {Link} from 'react-router-dom'
import '../../App.css';
import '../Css/HomeStyle.css'


function Home() {

      const handleButtonHover = (event) => {
        event.target.style.color = '#afafaf';
      };
      const handleButtonLeave = (event) => {
        event.target.style.color = '#eeece9';
      };

return (
<>
  <div className="Home">
    <h1 className="title">NIEBLA</h1>
        <div className="divButton">
            <Link className="buttonStyle"
            onMouseEnter={handleButtonHover}
            onMouseLeave={handleButtonLeave} to='/Estudio'>estudio</Link>

            <p className="slash">|</p>
            <Link className="buttonStyle"
            onMouseEnter={handleButtonHover}
            onMouseLeave={handleButtonLeave} to='/Films'>films</Link>

            <p className="slash">|</p>
            <Link className="buttonStyle"
            onMouseEnter={handleButtonHover}
            onMouseLeave={handleButtonLeave} to='/Festival'>festival</Link>
        </div>
    </div>
</>
  )
}

export default Home; 